"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatalogEditColors = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var icons_1 = require("@ant-design/icons");
var messageContext_1 = require("../../hoc/messageContext");
var react_router_dom_1 = require("react-router-dom");
var catalogCarSlice_1 = require("../../redux/slice/catalogCarSlice");
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var card_1 = __importDefault(require("antd/es/card"));
var col_1 = __importDefault(require("antd/es/col"));
var row_1 = __importDefault(require("antd/es/row"));
var typography_1 = __importDefault(require("antd/es/typography"));
var color_picker_1 = __importDefault(require("antd/es/color-picker"));
var image_1 = __importDefault(require("antd/es/image"));
var Title = typography_1.default.Title;
function rgbToHex(_a) {
    var r = _a.r, g = _a.g, b = _a.b;
    var toHex = function (component) { return component.toString(16).padStart(2, '0'); };
    return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b));
}
var CarCatalogEditColors = function () {
    var id = (0, react_router_dom_1.useParams)().id;
    var form = form_1.default.useForm()[0];
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, messageContext_1.useMessageContext)(), showSuccess = _a.showSuccess, showError = _a.showError;
    var catalogCar = (0, react_redux_1.useSelector)(selectors_1.catalogCarSelector).catalogCar;
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var handleAdd = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_colors"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                car_color: {
                                    car_catalog_id: catalogCar === null || catalogCar === void 0 ? void 0 : catalogCar.id,
                                    image: values.image,
                                    background: values.background,
                                    name: values.name,
                                },
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                    return [4 /*yield*/, response.json()];
                case 2:
                    res = _a.sent();
                    showSuccess('Изображение добавлено');
                    form.resetFields();
                    setLoading(false);
                    console.log(res);
                    return [3 /*break*/, 4];
                case 3:
                    showError('Ошибка при добавлении изображения');
                    setLoading(false);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onDelete = function (imageId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_colors/").concat(imageId), {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                        showSuccess('Изображение успешно удалено');
                        setLoading(false);
                    }
                    else {
                        showError('Ошибка при удалении изображения');
                        setLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpdate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_colors/").concat(values.image_id), {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                car_color: {
                                    car_catalog_id: catalogCar === null || catalogCar === void 0 ? void 0 : catalogCar.id,
                                    image: values.image,
                                    background: values.background,
                                    name: values.name,
                                },
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.sent();
                    showSuccess('Изображение обновленно');
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    showError('Ошибка при обновлении изображения');
                    setLoading(false);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { style: { padding: '20px' } },
        react_1.default.createElement(Title, { level: 1, style: { marginBottom: '20px' } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C/\u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C/\u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0441 \u0446\u0432\u0435\u0442\u043E\u043C \u043C\u0430\u0448\u0438\u043D"),
        react_1.default.createElement(card_1.default, { style: { marginBottom: '20px' } },
            react_1.default.createElement(form_1.default, { form: form, layout: "inline", onFinish: function (values) {
                    var updateValues = __assign(__assign({}, values), { background: rgbToHex(values.background.metaColor) });
                    handleAdd(updateValues);
                }, style: { marginBottom: '20px' } },
                react_1.default.createElement(form_1.default.Item, { name: "image", rules: [
                        { required: true, message: 'Введите URL изображения' },
                        { type: 'url', message: 'Введите корректный URL' },
                    ], style: { flex: 1 } },
                    react_1.default.createElement(input_1.default, { placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 URL \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F" })),
                react_1.default.createElement(form_1.default.Item, { name: "background", rules: [{ required: true, message: 'Цвет обязателен' }] },
                    react_1.default.createElement(color_picker_1.default, { format: "hex" })),
                react_1.default.createElement(form_1.default.Item, { name: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" },
                    react_1.default.createElement(input_1.default, null)),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: loading }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435")))),
        catalogCar && catalogCar.car_catalog_images.length > 0 ? (react_1.default.createElement(row_1.default, { gutter: [16, 16] }, catalogCar.car_colors.map(function (image) { return (react_1.default.createElement(col_1.default, { xs: 24, sm: 12, md: 8, lg: 6, key: image.id },
            react_1.default.createElement(card_1.default, { hoverable: true, cover: react_1.default.createElement("div", { style: { height: '200px', overflow: 'hidden', padding: '12px' } },
                    react_1.default.createElement(image_1.default, { alt: "car", src: image.image, style: {
                            width: '100%',
                            height: '200px',
                            objectFit: 'cover',
                        }, preview: {
                            mask: 'Просмотр',
                        } })), actions: [
                    react_1.default.createElement(button_1.default, { key: "delete", type: "text", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null), onClick: function () { return onDelete(image.id); } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"),
                ] },
                react_1.default.createElement(card_1.default.Meta, { description: "ID: ".concat(image.id) }),
                react_1.default.createElement(form_1.default, { layout: "vertical", initialValues: {
                        image: image.image,
                        background: image.background,
                        name: image.name,
                    }, onFinish: function (values) {
                        if (typeof values.background !== 'string') {
                            var updateValues = __assign(__assign({}, values), { image_id: image.id, background: rgbToHex(values.background.metaColor) });
                            handleUpdate(updateValues);
                        }
                        else {
                            var updateValues = __assign(__assign({}, values), { image_id: image.id });
                            handleUpdate(updateValues);
                        }
                    }, style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                        gap: '10px',
                    } },
                    react_1.default.createElement("div", { style: {
                            display: 'flex',
                            gap: '10px',
                        } },
                        react_1.default.createElement(form_1.default.Item, { name: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u0440\u0430\u0441\u043A\u0438", style: {
                                margin: '0px',
                            } },
                            react_1.default.createElement(input_1.default, null)),
                        react_1.default.createElement(form_1.default.Item, { name: "background", label: "\u0426\u0432\u0435\u0442", style: {
                                margin: '0px',
                            }, rules: [{ required: true, message: 'Цвет обязателен' }] },
                            react_1.default.createElement(color_picker_1.default, { format: "hex" }))),
                    react_1.default.createElement(form_1.default.Item, { name: "image", label: "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435", rules: [
                            { required: true, message: 'Введите URL изображения' },
                            { type: 'url', message: 'Введите корректный URL' },
                        ], style: {
                            display: 'flex',
                            alignSelf: 'start',
                            width: '100%',
                        } },
                        react_1.default.createElement(input_1.default, null)),
                    react_1.default.createElement(form_1.default.Item, null,
                        react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", icon: react_1.default.createElement(icons_1.SaveOutlined, null), loading: loading }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F")))))); }))) : (react_1.default.createElement("div", { style: { textAlign: 'center', padding: '20px' } },
            react_1.default.createElement(typography_1.default.Text, { type: "secondary" }, "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439")))));
};
exports.CarCatalogEditColors = CarCatalogEditColors;
